import {
  TrendingUp,
  Repeat,
  Layers,
  GraduationCap,
  HeartHandshake,
  ShieldCheck,
  HeartPulse,
  BookOpen,
  Briefcase,
  Gem,
} from "lucide-react";

export const COMPANY = {
  name: "Aryaki Finserv",
  planner: "E.L.S. Ranjan",
  role: "Certified Financial Planner",
  phone: "+91 97048 67788",
  whatsapp: "919704867788",
  email: "aryaki.finserv@gmail.com",
  address: "Vijayawada, Andhra Pradesh, India",
};

export const IMAGES = {
  heroTexture:
    "https://images.unsplash.com/photo-1552084850-3c5b6222bbe8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwyfHx3ZWFsdGglMjBtYW5hZ2VtZW50JTIwbHV4dXJ5JTIwYXJjaGl0ZWN0dXJlfGVufDB8fHx8MTc4NDg1NzU3M3ww&ixlib=rb-4.1.0&q=85",
  planner: "/advisor.jpg",
  family:
    "https://images.unsplash.com/photo-1628705250580-80b96d4657f6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHwyfHxoYXBweSUyMGZhbWlseSUyMHBsYW5uaW5nJTIwZnV0dXJlJTIwbGlmZXN0eWxlfGVufDB8fHx8MTc4NDg1NzU3NHww&ixlib=rb-4.1.0&q=85",
  abstract:
    "https://images.pexels.com/photos/6203470/pexels-photo-6203470.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

// Featured (highlighted) services first
export const SERVICES = [
  {
    id: "mutual-funds",
    tag: "01",
    title: "Mutual Funds",
    icon: TrendingUp,
    featured: true,
    blurb:
      "Curated equity, debt and hybrid portfolios aligned to your goals, risk appetite and horizon — reviewed and rebalanced with discipline.",
  },
  {
    id: "sip",
    tag: "02",
    title: "Systematic Investment Plans",
    icon: Repeat,
    featured: true,
    blurb:
      "Turn small, regular contributions into serious long-term wealth. We engineer SIPs that compound quietly and relentlessly.",
  },
  {
    id: "sif",
    tag: "03",
    title: "Specialized Investment Funds",
    icon: Layers,
    featured: true,
    blurb:
      "Access differentiated strategies and thematic funds built for investors who want an edge beyond the ordinary index.",
  },
  {
    id: "child-education",
    tag: "04",
    title: "Children Education Consultancy",
    icon: GraduationCap,
    featured: false,
    blurb:
      "Fund your child's ambitions with a goal-mapped plan that keeps pace with rising education costs.",
  },
  {
    id: "child-marriage",
    tag: "05",
    title: "Children Marriage Funding",
    icon: HeartHandshake,
    featured: false,
    blurb:
      "Prepare for life's biggest celebrations without last-minute financial stress through structured accumulation.",
  },
  {
    id: "financial-education",
    tag: "06",
    title: "Financial Education",
    icon: BookOpen,
    featured: false,
    blurb:
      "Clear, jargon-free guidance so you understand exactly how, where and why your money works.",
  },
  {
    id: "life-insurance",
    tag: "07",
    title: "Life Insurance",
    icon: ShieldCheck,
    featured: false,
    blurb:
      "Protect the people who depend on you with the right cover — never over-sold, always right-sized.",
  },
  {
    id: "health-insurance",
    tag: "08",
    title: "Health Insurance",
    icon: HeartPulse,
    featured: false,
    blurb:
      "Shield your savings from medical shocks with cover that actually pays when it matters.",
  },
  {
    id: "pms",
    tag: "09",
    title: "Portfolio Management Services",
    icon: Briefcase,
    featured: false,
    blurb:
      "Professionally managed, personalised portfolios for high-net-worth investors seeking active, discretionary expertise.",
  },
  {
    id: "aif",
    tag: "10",
    title: "Alternative Investment Funds",
    icon: Gem,
    featured: false,
    blurb:
      "Access sophisticated, SEBI-registered strategies beyond traditional markets to diversify and elevate your wealth.",
  },
];

export const PROCESS = [
  {
    n: "01",
    title: "Discover",
    body: "We start by understanding your life, not just your ledger — your goals, fears, family and timelines.",
  },
  {
    n: "02",
    title: "Design",
    body: "A bespoke roadmap mapping every goal to the right instrument, from SIPs to specialized funds and protection.",
  },
  {
    n: "03",
    title: "Deploy",
    body: "We execute with precision — the right funds, the right allocation, automated and tax-aware.",
  },
  {
    n: "04",
    title: "Review",
    body: "Markets move, life changes. We rebalance and refine so your plan stays on course, year after year.",
  },
];

export const STATS = [
  { value: "20+", label: "Years of guidance" },
  { value: "800+", label: "Families served" },
  { value: "4.9/5", label: "Client rating" },
];

export const TESTIMONIALS = [
  {
    quote:
      "E.L.S. Ranjan made investing feel calm and clear. Our SIPs are on autopilot and our children's education fund is finally on track.",
    name: "Ananya & Rohit",
    role: "Software Professionals, Vijayawada",
  },
  {
    quote:
      "The most honest advisor I've met. No jargon, no pushy insurance — just a plan that actually fits our family.",
    name: "Meenakshi R.",
    role: "Business Owner",
  },
  {
    quote:
      "Aryaki Finserv restructured my portfolio into specialized funds. The clarity and returns speak for themselves.",
    name: "Karthik V.",
    role: "Doctor",
  },
];
